import React, { FC } from 'react';
import { useBidWorkspace } from 'src/models/bids/Bids/hooks';
import styles from '../index.module.scss';
import WorkspaceBadge, { WorkspaceBadgeMode } from 'src/common/WorkspaceBadge';
import { IBidIdentifier } from 'src/models/bids/Bids/types';

interface IProps {
  bid?: IBidIdentifier;
  mode?: WorkspaceBadgeMode;
}

export const WSLabel: FC<IProps> = props => {
  const { bid, mode } = props;
  const { workspace: currentWorkspace } = useBidWorkspace(bid && bid.id);

  return (
    <>
      {currentWorkspace && (
        <WorkspaceBadge
          title={currentWorkspace.name}
          color={currentWorkspace.color}
          mode={mode}
          className={styles.wsButtonBadge}
        />
      )}
    </>
  );
};
export default WSLabel;
